module.exports = __webpack_public_path__ + "static/media/camera.eff9630e.svg";